import { cn } from "@/lib/utils";
import { PageHeader } from "@/components/PageHeader";

export interface PageContainerProps {
    className?:string;
    title?: string;
    children:React.ReactNode
}

export function PageContainer({className, title, children}: PageContainerProps){
    return (
        <div className={cn("flex flex-1 h-full w-full flex-col", className)}>
            {title && <PageHeader title={title} />}
            {children}
        </div>
    )
}